/**
 * Analytics-related Redux Actions
 */

/* tslint:disable:max-line-length */
import actionCreatorFactory, { Action } from 'typescript-fsa';
import { IQueryStringState } from '../../contexts/queryString/types';

const actionCreator = actionCreatorFactory('Analytics');

// SetLicense Action

export type SetLicenseAction = Action<string>;

export const setLicense = actionCreator<string>('SET_LICENSE');

// SetSearch Action
export type ISetSearchActionPayload = Pick<IQueryStringState, 'filters' | 'query'>;

export type SetSearchAction = Action<ISetSearchActionPayload>;

export const setSearch = actionCreator<ISetSearchActionPayload>('SET_SEARCH');

// SimilaritySearch Action
// DO NOT MODIFY existing values to preserve analytics data consistency.
export type ActionSource = 'search_results_list' | 'track_details_list' | 'project_list' |
  'shared_project_list' | 'player_terms_panel' | 'collection_page' | 'track_page' | 'featured_tracks_list' |
  'cart_page' | 'artist_page';

export interface ISimilaritySearchActionPayload {
  trackId: string;
  actionSource: ActionSource;
}
export type SimilaritySearchAction = Action<ISimilaritySearchActionPayload>;
export const similaritySearch = actionCreator<ISimilaritySearchActionPayload>('SIMILARITY_SEARCH');

// Set budget action
export const trackSetBudget = actionCreator<GQL.ITrackSearchBudgetFilter>('TRACK_SET_BUDGET');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/analytics.ts